import { render, staticRenderFns } from "./HomeEnergyReportButton.vue?vue&type=template&id=ccfed80c&scoped=true"
import script from "./HomeEnergyReportButton.vue?vue&type=script&lang=js"
export * from "./HomeEnergyReportButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfed80c",
  null
  
)

export default component.exports